import { cn } from "@/lib/utils";
import PowerLevels from "./PowerLevels";
import ModelPreview from "./ModelPreview";

interface PreviewOverviewProps {
  selectedModel: string;
  aspectRatio: string;
  contained?: boolean;
}

const PreviewOverview: React.FC<PreviewOverviewProps> = ({
  selectedModel,
  aspectRatio,
  contained = false,
}) => {
  return (
    <div
      className={cn(
        "tw:flex tw:flex-col tw:gap-2 tw:mt-4",
        contained && "tw:border tw:border-[#E8E8E8] tw:rounded-sm tw:mb-4"
      )}
    >
      <PowerLevels selectedModel={selectedModel} />
      <ModelPreview
        aspectRatio={aspectRatio.replace(":", " / ")}
        selectedModel={selectedModel}
      />
    </div>
  );
};

export default PreviewOverview;
